<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Span" });
import "tailwindcss/tailwind.css";
import { t } from "svelte-i18n";
export let label = "";
export let size = void 0;
export let style = "regular";
export let css = "";
export let color = void 0;
const HAS_SLOT = "default" in $$slots;
$: cssColor = color === void 0 ? "" : `s8-${color}`;
$: cssSize = size === void 0 ? "" : `s8-${size}`;
$: cssStyle = `s8-${style}`;
</script>

{#if HAS_SLOT || Boolean(label)}
    <span
        class = { `${ cssStyle } ${ cssColor } ${ cssSize } ${ css }` }
        on:click
        on:keypress
    >
        {#if HAS_SLOT }
            <slot>Hello World</slot>
        {/if}
        {#if label !== undefined}
            { $t(label) }
        {/if}
    </span>
{/if}


<style>
    span {
        display: inline-block;
}

    span.s8-semibold {
        font-weight: 600;
}

    span.s8-lg {
        font-size: 14px;
    }

    span.s8-md {
        font-size: 12px;
    }

    span.s8-sm {
        font-size: 10px;
    }

    span.s8-xs {
        font-size: 9px;
    }

    span.s8-error {
        color: #EF233B;
    }

    span.s8-warning {
        color: #EFC923;
    }

    span.s8-success {
        color: #44835F;
    }

    span.s8-info {
        color: #446083;
    }

    span.s8-subtle {
        color: #979691;
    }

    span.s8-dark {
        color: #272711;
    }

    span.s8-light {
        color: #FFFFFF;
    }</style>